import classNames from "classnames";
import React, { useContext, useState } from "react";
import { useOutletContext } from "react-router-dom";
import venomContext from "../../context/venomContext";
import { toast } from "react-toastify";

export default function Profile() {
  const [currentUser, userImg] = useOutletContext();
  const context = useContext(venomContext);
  const { updateUserProfile, loggedInUser } = context;
  const { _id, name, email } = currentUser;
  const [userInfo, setUserInfo] = useState({ name: "", updatePassword: "" });
  const [showPass, setShowPass] = useState(false);
  const theme_color = localStorage.getItem("theme");
  const onChangeHandler = (e) => {
    setUserInfo({
      ...userInfo,
      [e.target.name]: e.target.value,
    });
  };
  const togglePassHandler = () => {
    setShowPass(!showPass);
  };
  const updateProfileHandler = () => {
    if (userInfo.updatePassword === "" || userInfo.updatePassword.length < 5) {
      return toast.warn("All fields are required", {
        position: "bottom-right",
      });
    }
    updateUserProfile(
      _id,
      userInfo.name !== "" ? userInfo.name : name,
      userInfo.updatePassword,
      userImg.userProfile
    );
  };
  return (
    <>
      <div className={"user-biodata " + theme_color}>
        <div className="d-flex justify-content-between">
          <div className="form-group">
            <label className="form-label" htmlFor="name">
              Name
            </label>
            <input
              type="text"
              value={!userInfo.name ? name : userInfo.name}
              onChange={onChangeHandler}
              className="form-control"
              name="name"
              placeholder="Name..."
              id="name"
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input
              value={email}
              readOnly={true}
              type="email"
              className="form-control"
              name="email"
              placeholder="Email..."
              id="email"
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="updatePassword">
              Update Password
            </label>
            <div className="content-last">
              <input
                type={showPass !== true ? "password" : "text"}
                onChange={onChangeHandler}
                className="form-control"
                name="updatePassword"
                placeholder="Password..."
                id="updatePassword"
              />
              <div className="show-pass-btn">
                <i
                  className={classNames(
                    "fal",
                    { " fa-eye": showPass !== true },
                    { " fa-eye-slash": showPass === true }
                  )}
                  style={{ cursor: "pointer" }}
                  onClick={togglePassHandler}
                ></i>
              </div>
            </div>
          </div>
          <div className="form-group">
            <button
              className={"btn btn-md btn-" + theme_color}
              onClick={() => {
                updateProfileHandler();
                setTimeout(async () => {
                  loggedInUser();
                }, 10000);
              }}
            >
              <i className="fal fa-spinner-third me-2 loading d-none"></i>
              Update Profile
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
